/*
 * First `n` characters of a string. Iterating with Array.from (rather than
 * indexing the string) iterates whole characters, so multi-byte characters like
 * certain CJK glyphs aren't split in half.
 */
const firstChars = (token: string, n: number): string =>
  Array.from(token).slice(0, n).join('')

export const getNameInitials = (name?: string | null): string => {
  const trimmed = name?.trim()
  if (!trimmed) return ''

  const tokens = trimmed.split(/\s+/)

  if (tokens.length === 1) {
    return firstChars(tokens[0], 2).toUpperCase()
  }

  const firstInitial = firstChars(tokens[0], 1)
  const lastInitial = firstChars(tokens[tokens.length - 1], 1)

  return (firstInitial + lastInitial).toUpperCase()
}
